const { API_URL } = require("../utils/constants")
const { default: apiHelper } = require("./apiHelper")

exports.getLogContent = (data) => {
    return apiHelper({ method: "get", path: `${API_URL}/logs/${data?.service?.en}/files/${data.id}` })
}
